module.exports = __webpack_public_path__ + "img/huawei.eb5f9eb2.png";